








import mixins from 'vue-typed-mixins';
import PolledPaymentCompletionMixin from '@/Payment/PolledPaymentCompletionMixin';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentProcessor } from '@/Payment/Enums';

const component = mixins(LocationBasedMixin, PolledPaymentCompletionMixin).extend({
    props: {
        transactionId: {
            type: String,
            required: true
        }
    }
});

export default component;
